/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getAccountPreferences.defs.js'
export { main as default } from './getAccountPreferences.defs.js'
